<template>
  <span>
    <Select
      :value="value"
      @input="inputHandler"
      clearable
      v-bind="selectProps"
      style="width: 200px;"
    >
      <Option v-for="api in options" :key="api.value" :value="api.value">
        {{api.label}}
      </Option>
    </Select>
  </span>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    formItemProps: {
      type: Object,
      default: () => ({})
    },
    selectProps: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    ...mapState('setting', [
			'apiSettings',
    ]),
    itemProps() {
      return {
        ...this.formItemProps,
      }
    },
    options() {
      const keys = Object.keys(this.apiSettings);
      return keys.map(key => ({
        label: this.apiSettings[key].name,
        value: key,
      }))
    }
  },
  methods: {
    inputHandler(val) {
      this.$emit('input', val)
    }
  }
}
</script>